import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import colors from '../colors'
import { Typography } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'

 
const useStyles = makeStyles((theme) => ({
  applied: {
    color: colors.applied,
  },
  applying: {
    color: colors.applying,
  },
  following: {
    color: colors.following,
  },
  tooltip: {
    margin: theme.spacing(2),
    '& tr': {
      '& td:nth-child(2)': {
        textAlign: 'right',
      },
      '& td': {
        padding: theme.spacing(0.5),
      },
    },
    '& tbody': {
      '& tr:first-child td': {
        borderTop: '1px solid lightgrey',
      },
      '& tr:last-child td': {
        borderBottom: '1px solid lightgrey',
      },
      '& td:nth-child(2)': {
        fontWeight: 'bold',
      },
    },
    '& tfoot, & thead': {
      textAlign: 'center',
    },
  },
}))

const TooltipContent = ({ segment }) => {
  const classes = useStyles()
  const applied = (segment && segment.data && segment.data.applied) || 0
  const applying = (segment && segment.data && segment.data.applying) || 0
  const following = (segment && segment.data && segment.data.following) || 0
  const total = applied + applying + following
  const month = segment.data.month

  return (
    <Typography variant="caption">
      <table className={classes.tooltip}>
        <thead>
          <tr>
            <th colSpan="3">{total.toLocaleString()} Total Students</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <FontAwesomeIcon
                icon={faCircle}
                size="sm"
                className={classes.applied}
              />
            </td>
            <td>{applied.toLocaleString()}</td>
            <td>Applied</td>
          </tr>
          <tr>
            <td>
              <FontAwesomeIcon
                icon={faCircle}
                size="sm"
                className={classes.applying}
              />
            </td>
            <td>{applying.toLocaleString()}</td>
            <td>Applying</td>
          </tr>
          <tr>
            <td>
              <FontAwesomeIcon
                icon={faCircle}
                size="sm"
                className={classes.following}
              />
            </td>
            <td>{following.toLocaleString()}</td>
            <td>Following</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="3">
              Month of <strong>{month}</strong>
            </td>
          </tr>
        </tfoot>
      </table>
    </Typography>
  )
}

TooltipContent.propTypes = {
  segment: PropTypes.any.isRequired,
}

export default TooltipContent
